let _navigate = null;
let _queue = [];

export const setNavigate = fn => {
  _navigate = fn;

  // Reset (ex: déconnexion / teardown de tests) : on vide la file.
  if (!fn) {
    _queue = [];
    return;
  }

  // Rejoue les navigations demandées avant le montage du router
  // (ex: Callback.componentDidMount qui s'exécute avant le useEffect de NavigateInjector)
  if (_queue.length) {
    const pending = _queue;
    _queue = [];
    pending.forEach(args => fn(...args));
  }
};

export const navigate = (...args) => {
  if (!_navigate) {
    // Le router n'est pas encore monté : on met l'appel en file d'attente
    // au lieu de le perdre, puis on le rejoue dans setNavigate.
    _queue.push(args);
    return;
  }
  _navigate(...args);
};
